export default __webpack_public_path__ + "static/couple0-a6b6d6a9d351172e62f6b9935def1061.png";